import { Entities } from "@/shared/indexer/entititiesTypes"
import type {
  ICLockProduct,
  ILlPhyProduct,
  IProduct,
} from "@repo/loomlock/model-types"

export enum TokenType {
  ERC721 = 0,
  ERC1155 = 1,
}

export enum Status {
  UNSET = 0,
  ACTIVE = 1,
  FILLED = 2,
  CANCELLED = 3,
}

export type Listing = Entities["MarketplaceListing"]
export type WithListing<T> = T & {
  listings: Listing[]
}
export type Offer = Entities["MarketplaceOffer"]
export type Sale = Entities["MarketplaceSale"]

export type ProductWithListing = IProduct & {
  listings: Listing[]
}

export interface ListingParameters {
  assetContract: string
  tokenId: bigint
  quantity: number
  currency: string
  pricePerToken: bigint
  startTimestamp: bigint
  endTimestamp: bigint
  reserved: boolean
}

export interface OfferParams {
  assetContract: string
  tokenId: bigint
  quantity: number
  currency: string
  totalPrice: bigint
  expirationTimestamp: bigint
}

// Native ETH address constant (as specified in documentation)
export const NATIVE_TOKEN_ADDRESS = "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee"

// Helper function to check if currency is native ETH
export const isNativeCurrency = (currency: string): boolean =>
  currency.toLowerCase() === NATIVE_TOKEN_ADDRESS.toLowerCase()
